module.exports = __webpack_public_path__ + "img/CCLF_infographic-09.cb64c7c6.png";